import { Dispatch, type FC } from 'react';

// MUI
import { Box } from '@mui/material';

// screen
import { TemplateSettings } from 'modules/map/components/daily-dish/types';
import { SettingsAction } from 'modules/map/components/daily-dish/reducer';
import { SwitchField, FormFieldRow } from 'modules/map/components/daily-dish/components/form';
import { LOGO_CONFIG } from 'modules/map/components/daily-dish/config';

interface ToggleLogosProps {
  settings: TemplateSettings;
  dispatch: Dispatch<SettingsAction>;
}

const ToggleLogos: FC<ToggleLogosProps> = ({ settings, dispatch }) => {
  return (
    <Box sx={{ my: 2 }}>
      <FormFieldRow gap={1}>
        {LOGO_CONFIG.map((item) => (
          <SwitchField
            key={item.settingKey}
            label={`${item.label}:`}
            checked={settings.general.showLogo[item.settingKey]}
            onChange={(checked) =>
              dispatch({
                type: 'UPDATE_LOGO',
                key: item.settingKey,
                value: checked,
              })
            }
          />
        ))}
      </FormFieldRow>
    </Box>
  );
};

export default ToggleLogos;
